module.exports = __webpack_public_path__ + "img/wlcy.8dd1a4f.png";